import { render, staticRenderFns } from "./QOnboardingRecruitingStatusDrilldown.vue?vue&type=template&id=2a541f06&scoped=true&"
import script from "./QOnboardingRecruitingStatusDrilldown.vue?vue&type=script&lang=js&"
export * from "./QOnboardingRecruitingStatusDrilldown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a541f06",
  null
  
)

export default component.exports